import { isNone } from '@ember/utils';
import FragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default FragmentSerializer.extend({
  normalize(type, data) {
    // Convert from key/value protobuf map-style representation received
    // from Cogs server into a representation that is Ember friendly
    if (!isNone(data.key)) {
      const item_modifier_option_id = data.key?.id;
      data = data.value;
      data.item_modifier_option_id = item_modifier_option_id;
    }
    return this._super(type, data);
  },
  serialize(snapshot, options) {
    // Convert from Ember friendly representation into key/value protobuf
    // map-style representation expected by Cogs server implementation
    const value = this._super(snapshot, options);
    const key = {
      id: value['item_modifier_option_id'],
      type: {
        'squareup.api.items.type': 'ITEM_MODIFIER_OPTION'
      }
    };
    delete value['item_modifier_option_id'];
    return {
      key,
      value
    };
  }
});